export const en = {
    campaign: 'Campaign',
    name: 'Name',
    status: 'Status',
    type: 'Type'
};
